import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import FlashError from '../../../../FlashMessage/FlashError';
import { previewStore } from '../LearningCollectionPreviewStore';

function ErrorMessage() {
  const { state } = previewStore;
  if (state.kind !== 'error') return emptyFragment();
  return (
    <FlashError
      children={
        <T kind="Something went wrong and the collection was not saved. Please try again." />
      }
    />
  );
}

export default observer(ErrorMessage);
